// extracted by mini-css-extract-plugin
export default {"wrapper":"select_wrapper__PJhhh","select":"select_select__fLX-o","error":"select_error__H0Nra","disabled":"select_disabled__wDifU"};